import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import pt from './locales/pt.json';

/**
 * i18n bootstrap — runs once at import time.
 *
 * Detection order:
 *   1. `localStorage.funnelhack_lng`
 *   2. browser navigator.language
 *   3. fallback → 'en' (per the original product spec: English default + PT switch)
 *
 * Supported: 'en' (default) and 'pt' (Portugal + Brazil rolled together).
 * If we ever split pt-BR vs pt-PT we'd add a third bundle.
 */
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      pt: { translation: pt },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'pt'],
    nonExplicitSupportedLngs: true, // map pt-BR and pt-PT → pt
    interpolation: { escapeValue: false }, // React already escapes
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'funnelhack_lng',
      caches: ['localStorage'],
    },
    returnEmptyString: false,
  });

export default i18n;
